import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  DisplayPosition,
  Image,
  Space,
  Text,
} from '@gousto-internal/citrus-react'
import PlaceholderImage from './StackedRecipePlaceholder.png'

const DashedBorder = () => (
  <svg width="100%" height="100%" style={{ position: 'absolute', top: 0, left: 0, zIndex: -1 }}>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      fill="none"
      stroke="#AEB7C0"
      strokeWidth="1"
      strokeDasharray="4,4"
    />
  </svg>
)

export const PlaceholderBanner = function () {
  return (
    <Box
      display="flex"
      alignItems={AlignItems.Center}
      gap={3}
      position={DisplayPosition.Relative}
      paddingV={1}
      width="100%"
      height="100%"
      maxWidth={['100%', '300px']}
      data-testId="placeholderBanner"
    >
      <DashedBorder />
      <Image
        alt="Placeholder recipe image"
        src={PlaceholderImage}
        height="40px"
        width="unset"
        style={{ marginBottom: '-0.3rem' }}
      />
      <Box flexGrow={1}>
        <Text size={2} fontWeight={700} color={Color.ColdGrey_800}>
          Add all the recipes you like
        </Text>
        <Text size={2} color={Color.ColdGrey_600}>
          Narrow down at checkout
        </Text>
      </Box>
      <Space direction="horizontal" size={8} />
    </Box>
  )
}
